import { enableProdMode } from '@angular/core';

import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { applyPortalTheme } from './app/shared/utils/portal-theme.util';
import { bootstrapApplication } from '@angular/platform-browser';

if (environment.production) {
  enableProdMode();
}
let datadogInfo = environment.datadogClientToken;
if (datadogInfo) {
  datadogRum.init({
    applicationId: environment.datadogApplicationId,
    clientToken: environment.datadogClientToken,
    site: 'us3.datadoghq.com',
    service: environment.datadogService,
    env: environment.env,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    version: environment.version,
    defaultPrivacyLevel: 'allow',
    allowedTracingUrls: [environment.baseUrl],
    beforeSend: (event, context) => {
      const errorStringsToIgnore = [
        'AG Grid',
        'ag-grid',
        'evaluation only version',
        'License Key Not Found',
        "Failed to start the transport 'WebSockets'",
        "Failed to start the transport 'ServerSentEvents'",
        'SignalR',
        'WebSocket',
        "Failed to start the transport 'LongPolling'",
        "No Connection with that ID: Status code '404'",
        'make sure you installed the scripts',
        'Error: WebSocket failed to connect',
        'Provided {"error":{},"text":"<!DOCTYPE html><html>',
      ];

      let regex = new RegExp(`(${errorStringsToIgnore.join('|')})`, 'i');
      return !(
        event.type === 'error' &&
        (Boolean(event.error.message.match(regex)) ||
          event.error.message.includes('********'))
      );
    },
  });
  datadogRum.startSessionReplayRecording();

  datadogLogs.init({
    clientToken: environment.datadogClientToken,
    site: 'us3.datadoghq.com',
    forwardErrorsToLogs: true,
  });
}
(function hydrateThemeFromCache() {
  try {
    const cached = localStorage.getItem('portalConfig');
    if (!cached) return;
    const config = JSON.parse(cached);
    applyPortalTheme(document.documentElement, config);
  } catch {
    // Bad JSON in localStorage — ignore, defaults will apply
  }
})();

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
